import React, {useMemo, useState} from "react";
import dayjs from "dayjs";

// Components
import {Dialog} from "../../../../designSystem/components/Dialog";
import {BigButton} from "../../../../designSystem/components/BigButton";

import {ADD_MEASURE_MODAL_CONTENTS, AddMeasureModalContent} from "../AddMeasureModalContent";
import { useAddMeasure } from "../../hooks/useAddMeasure";
import {validateMeasure} from "../../model/validateMeasure";
import {METRICS} from "../../../../utils/constants";

export const AddMeasureFeature = ({
  lineUserId,
  onChangeSelectedMetric,
  onSwitchToVisualization,
}) => {
  const [selectedMetric, setSelectedMetric] = useState<string | null>(null);
  const [modalContent, setModalContent] = useState<ADD_MEASURE_MODAL_CONTENTS | ''>('');
  const [measurement, setMeasurement] = useState<object | null>({});
  const [measureDateTime, setMeasureDateTime] = useState(dayjs());

  const { submit } = useAddMeasure({
    lineUserId,
    selectedMetric,
    measurement,
    measureDateTime,
    setModalContent
  })

  const onPressMetric = (key: string) => {
    setSelectedMetric(key);
    onChangeSelectedMetric(key);
    setMeasurement({});
    setModalContent(ADD_MEASURE_MODAL_CONTENTS.FORM);
  };

  const onChangeMeasurement = m => setMeasurement(m);
  const onChangeMeasureDateTime = (newVal) => setMeasureDateTime(newVal)
  const onCloseDialog = () => setModalContent('');

  const onClickGoToVisualization = () => {
    setModalContent('');
    onSwitchToVisualization();
  }

  const isValid = useMemo(() => {
    return validateMeasure(selectedMetric, measurement)
  }, [selectedMetric, measurement]);

  return (
    <React.Fragment>
      {/* === 5 BUTTON GRID === */}
      <div className="px-4 py-2 grid grid-cols-2 sm:grid-cols-3 gap-4 w-full max-w-4xl">
        {METRICS.map((metric) => (
          <BigButton
            key={metric.key}
            onClick={() => onPressMetric(metric.key)}
            color={metric.color}
            icon={metric.icon}
            label={metric.label}
          />
        ))}
      </div>

      <Dialog isOpen={modalContent !== ''}>
        {AddMeasureModalContent({
          isValid,
          measureDateTime,
          measurement,
          submitMeasurement: submit,
          selectedMetric,
          onCloseDialog,
          onClickGoToVisualization,
          onChangeMeasurement,
          onChangeMeasureDateTime,
        })[modalContent] || <></>}
      </Dialog>
    </React.Fragment>
  )
}